<template>
  <div
    class="absolute top-1/2 z-10 !flex -translate-y-1/2 !items-center !justify-center !bg-lightGray !shadow-md before:!content-none hover:!bg-white focus:ring-2 sm:!shadow-lg"
    :class="{
      '!border-l-0': side === 'left' && !small,
      '!border-r-0': side === 'right' && !small,
      '!left-0': side === 'left' && !outside,
      '!right-0': side === 'right' && !outside,
      '!right-full': side === 'left' && outside,
      '!left-full': side === 'right' && outside,
      '!h-20 !w-10 !border !border-solid !border-black-40 !p-2 lg:!h-28 lg:!w-14':
        !small,
      '!h-7 !w-7 !p-1': small,
    }"
    role="button"
    :aria-label="ariaLabel"
  >
    <IconArrowLeft
      class="text-black"
      :class="{
        'rotate-180': side !== 'left',
      }"
    />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const props = defineProps({
  side: {
    type: String as PropType<'left' | 'right'>,
    required: true,
    validator: (val: string) => ['left', 'right'].includes(val),
  },
  small: {
    type: Boolean as PropType<boolean>,
    default: () => false,
  },
  outside: {
    type: Boolean as PropType<boolean>,
    default: () => false,
  },
})

const { t } = useI18n()

const ariaLabel = computed(() => {
  return props.side === 'left'
    ? t('navigation.pagination.previous')
    : t('navigation.pagination.next')
})
</script>
